import React, { memo } from 'react'
import cx from 'classnames'
import { Icons, Icon } from '../icon'
import { SortConfig } from './hooks/useTableSort'

interface TableHeaderCellProps {
  children: React.ReactNode
  column?: string
  sortConfig?: SortConfig
  align?: 'left' | 'center' | 'right'
  // TODO: Antonio revisar si se puede quitar el no-unused-vars
  // eslint-disable-next-line no-unused-vars
  onSort?: (column: string) => void
}

const TableHeaderCell = memo(
  ({
    children,
    column,
    sortConfig,
    align = 'left',
    onSort,
  }: TableHeaderCellProps) => {
    return (
      <th
        className={cx('table-header-cell', align, {
          'is-sortable': onSort,
        })}
        onClick={() => onSort?.(column ?? '')}
      >
        <div
          className={cx('table-header-cell-content', {
            'not-visible': !sortConfig?.direction,
          })}
        >
          {children}
          {onSort && (
            <Icon
              size={14}
              name={
                sortConfig?.direction === 'asc'
                  ? Icons.ChevronUp
                  : Icons.ChevronDown
              }
            />
          )}
        </div>
      </th>
    )
  },
)

TableHeaderCell.displayName = 'TableHeaderCell'
export default TableHeaderCell
